import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Rajesh Kumar',
    location: 'Green Park, Delhi',
    rating: 5,
    text: 'Excellent quality mattresses at very reasonable prices. The staff was very helpful in choosing the right mattress for my back pain. Highly recommended!',
  },
  {
    name: 'Priya Sharma',
    location: 'Malviya Nagar, Delhi',
    rating: 5,
    text: 'Bought Sleepwell mattress and bedsheets from here. Great products and the owner Mr. Aggarwal personally guided us. Will definitely come back!',
  },
  {
    name: 'Amit Singh',
    location: 'Hauz Khas, Delhi',
    rating: 5,
    text: 'Been buying from Aggarwal Foam Palace for over 10 years. Trustworthy shop with genuine products. The best foam shop in South Delhi!',
  },
];

export const Testimonials = () => {
  return (
    <section 
      data-testid="testimonials-section"
      className="py-16 md:py-24 bg-stone-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-medium tracking-widest uppercase text-teal-700 mb-3">
            Customer Reviews
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Join thousands of satisfied customers who found their perfect sleep with us
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              data-testid={`testimonial-card-${index}`}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-shadow border border-stone-100"
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-teal-200 mb-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-amber-500 fill-current" />
                ))}
              </div>
              
              {/* Text */}
              <p className="text-stone-600 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              
              {/* Author */}
              <div className="border-t border-stone-100 pt-4">
                <p className="font-semibold text-stone-800">{testimonial.name}</p>
                <p className="text-sm text-stone-500">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Google Rating Badge */}
        <div className="mt-12 text-center">
          <a 
            href="https://maps.app.goo.gl/tLGnG1nKfKTFJZHaA"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-3 bg-white px-6 py-3 rounded-full shadow-sm hover:shadow-md transition-shadow border border-stone-100"
          >
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className={`w-5 h-5 ${i < 4 ? 'text-amber-500 fill-current' : 'text-amber-500 fill-current opacity-50'}`} />
              ))}
            </div>
            <span className="text-stone-800 font-medium">4.5/5 on Google</span>
            <span className="text-stone-400">|</span>
            <span className="text-teal-600 font-medium">See All Reviews</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
